import gql from 'graphql-tag';

import duplicateFilesPageFragment from '../fragments/duplicateFilesPageFragment';

export const queryDuplicateFilesPage = gql`
  query duplicateFilesPage(
    $count: Int
    $offset: Int
    $orderBy: SearchResultOrderByType
    $orderByDirection: OrderByDirection
  ) {
    duplicateFilesPage(
      count: $count
      offset: $offset
      orderBy: $orderBy
      orderByDirection: $orderByDirection
    ) {
      ...duplicateFilesPageFragment
    }
  }
  ${duplicateFilesPageFragment}
`;
export default queryDuplicateFilesPage;
